import script from "./ZohoSalesIQ.vue?vue&type=script&setup=true&lang=ts"
export * from "./ZohoSalesIQ.vue?vue&type=script&setup=true&lang=ts"

import "./ZohoSalesIQ.vue?vue&type=style&index=0&id=315c0f06&lang=css"

const __exports__ = script;

export default __exports__